export type EntitlementStatus = "ACTIVE" | "EXPIRED" | "REVOKED" | "SUSPENDED";

export function calculateResultingExpiry(
  now: Date,
  currentExpiry: Date | null,
  durationSeconds: number,
): Date {
  if (!Number.isSafeInteger(durationSeconds) || durationSeconds <= 0) {
    throw new Error("Duration must be a positive safe integer");
  }

  const base =
    currentExpiry !== null && currentExpiry.getTime() > now.getTime()
      ? currentExpiry
      : now;
  return new Date(base.getTime() + durationSeconds * 1_000);
}

export function effectiveEntitlementStatus(
  status: EntitlementStatus,
  expiresAt: Date | null,
  now: Date,
): EntitlementStatus {
  if (status !== "ACTIVE") {
    return status;
  }
  if (expiresAt !== null && expiresAt.getTime() <= now.getTime()) {
    return "EXPIRED";
  }
  return "ACTIVE";
}
